export const arrays = {
  // TODO replace with Array.toSorted
  toSorted: <T>(list: T[], fn: (a: T, b: T) => number): T[] => {
    const newList = list.slice(0);
    newList.sort(fn);
    return newList;
  },

  moveToFirst<T>(list: T[], fn: (item: T) => boolean): T[] {
    const index = list.findIndex(fn);
    if (index === -1 || index === 0) return list;

    const newList = [...list];
    const [chat] = newList.splice(index, 1);
    newList.unshift(chat);
    return newList;
  },

  moveTargetAfterCondition<T>(
    list: T[],
    targetFn: (item: T) => boolean,
    conditionFn: (item: T) => boolean,
  ): T[] {
    const targetIndex = list.findIndex(targetFn);
    if (targetIndex === -1) return list;

    let lastMatchIndex = -1;
    for (let i = 0; i < list.length; i++) {
      if (i !== targetIndex && conditionFn(list[i])) {
        lastMatchIndex = i;
      }
    }

    if (lastMatchIndex === -1 || targetIndex > lastMatchIndex) return list;

    const newList = [...list];
    const [item] = newList.splice(targetIndex, 1);
    const insertIndex = targetIndex < lastMatchIndex ? lastMatchIndex : lastMatchIndex + 1;
    newList.splice(insertIndex, 0, item);
    return newList;
  },
};
